import { StateUf, states } from '@components/Sections/UfsPartners/states';
import { Partner } from '@src/types/strapi/collections/partners';
import { Dispatch, ReactNode, SetStateAction, createContext, useEffect, useState } from 'react';

type typePartnersContext = {
  partners: Partner[];
  setPartners: Dispatch<SetStateAction<Partner[]>>;
  partnersFiltered: Partner[];
  setPartnersFiltered: Dispatch<SetStateAction<Partner[]>>;
  stateSelected: StateUf;
  setStateSelected: Dispatch<SetStateAction<StateUf>>;
  partnerSelected: Partner;
  setPartnerSelected: Dispatch<SetStateAction<Partner>>;
  city: string;
  setCity: Dispatch<SetStateAction<string>>;
  neighborhood: string;
  setNeighborhood: Dispatch<SetStateAction<string>>;
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  partnersSearch: Partner[];
  setPartnersSearch: Dispatch<SetStateAction<Partner[]>>;
  handleFilter: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleClearFields: () => void;
  citiesOptions: Array<{ label: string; value: string }>;
  setCitiesOptions: Dispatch<SetStateAction<Array<{ label: string; value: string }>>>;
  neighborhoodOptions: Array<{ label: string; value: string }>;
  setNeighborhoodOptions: Dispatch<SetStateAction<Array<{ label: string; value: string }>>>;
}

export type OptionType = {
  label: string,
  value: string
};

export const FIRST_STATE = states[0]
export const PartnersContext = createContext({} as typePartnersContext)
export const PartnersProvider = ({ children }: { children: ReactNode }) => {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [partnersFiltered, setPartnersFiltered] = useState<Partner[]>(partners);
  const [stateSelected, setStateSelected] = useState(FIRST_STATE);
  const [partnerSelected, setPartnerSelected] = useState<Partner>({} as Partner);
  const [city, setCity] = useState<string>('');
  const [neighborhood, setNeighborhood] = useState<string>('');
  const [search, setSearch] = useState<string>('');
  const [partnersSearch, setPartnersSearch] = useState<Partner[]>([]);
  const [citiesOptions, setCitiesOptions] = useState<Array<OptionType>>([]);
  const [neighborhoodOptions, setNeighborhoodOptions] = useState<Array<OptionType>>([]);


  useEffect(() => {
    setPartnersFiltered(partners);
  }, [partners])

  useEffect(() => {
    if (!neighborhood.length && !city.length && !search.length) {
      setSearch('');
      setPartnersSearch([]);
    }
  }, [city, neighborhood, search]);

  const handleFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value.toLowerCase();
    setSearch(e.target.value);

    if (searchValue === '') {
      setPartnersSearch([]);
      return;
    }

    const filteredPartners = partnersFiltered.filter(partner =>
      partner.business_name.toLowerCase().includes(searchValue)
      || partner.city.toLowerCase().includes(searchValue)
      || partner.neighborhood.toLowerCase().includes(searchValue));

    setPartnersSearch(filteredPartners || []);
  }

  const handleClearFields = () => {
    setSearch('');
    setCity('');
    setNeighborhood('');
    setPartnersFiltered(partners);
  };

  return (
    <PartnersContext.Provider
      value={{
        partners,
        setPartners,
        stateSelected,
        setStateSelected,
        partnerSelected,
        setPartnerSelected,
        partnersFiltered,
        setPartnersFiltered,
        city,
        setCity,
        neighborhood,
        setNeighborhood,
        search,
        setSearch,
        partnersSearch,
        setPartnersSearch,
        handleFilter,
        handleClearFields,
        citiesOptions,
        setCitiesOptions,
        neighborhoodOptions,
        setNeighborhoodOptions
      }}
    >
      {children}
    </PartnersContext.Provider>
  )
}
